import { render, staticRenderFns } from "./CorrelationContent.vue?vue&type=template&id=5daab3d6&scoped=true&"
import script from "./CorrelationContent.vue?vue&type=script&lang=ts&"
export * from "./CorrelationContent.vue?vue&type=script&lang=ts&"
import style0 from "./CorrelationContent.vue?vue&type=style&index=0&id=5daab3d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5daab3d6",
  null
  
)

export default component.exports